import { Container, MainWrapper } from 'lib/components/styles/layout';
import React from 'react';
import { Typography } from 'react-covideo-common';
import styled, { useTheme } from 'styled-components/macro';

const UnorderedList = styled.ul`
  padding-left: 20px;
  margin-bottom: 25px;
`;

const OrderedList = styled.ol`
  padding-left: 20px;
  margin-bottom: 15px;
`;

const NestedOrderedList = styled.ol`
  padding-left: 20px;
  margin-bottom: 10px;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
`;

const LegalLink = styled.a`
  text-decoration: underline;
  color: #196fe1;
`;

export const TermsAndConditions = () => {
  const { colors } = useTheme();
  return (
    <Container style={{ color: colors.black[100] }}>
      <MainWrapper resetPadding={false}>
        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          Welcome to CDK CRM Video
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          To use CDK CRM Video (the "Application"), You must first accept these
          terms ("Terms"). As used herein, "You" refers to the Dealership
          (defined below) and its employee using the Application and agreeing to
          these Terms, and "We", "Our", and "CDK" refer to CDK Global, LLC. You
          accept and agree to these Terms on Your own behalf and/or on behalf of
          Your dealership ("Dealership"), by clicking "I Agree" below. You
          represent that You have the right and authority to accept these Terms
          on Your own behalf and on behalf of Your dealership.
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          Your use of the Application is subject to the terms and conditions of
          the Master Services Agreement between Your dealership and CDK Global,
          LLC and these Terms, which includes the Third-Party Provider Terms set
          forth below. You agree You and Your Dealership will comply with these
          Terms and fulfill Your obligations hereunder, including obtaining any
          required consents for Your customers' and Users' use of the
          Application. In the event of any conflict between the Third-Party
          Terms and Conditions and the Agreement regarding Your use of the
          Application, the Third-Party Terms and Conditions shall govern. No
          cause of action arising hereunder or relating hereto may be brought
          more than two (2) years after it first accrues.
        </Typography>

        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          Authorized Use
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You may use the Application on behalf and for the benefit of Your
          Dealership to communicate and share videos (collectively
          "Communications") with Your Dealership's customers and potential
          customers. As a condition to using the Application, You agree that You
          will use the Application only for the foregoing purpose and in the
          manner expressly permitted by these Terms and in accordance with all
          applicable laws and regulations.
        </Typography>

        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          User Consent
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You agree to comply with all applicable consents for Communications
          with Your customers and obtain express consent from all persons with
          whom You Communicate ("Users") prior to initiating any recording of
          any aspect of Your Communications set forth herein. You must notify
          and obtain consent from each User before recording begins and then
          such data must be used only as consented to by the User. You may not
          collect User or device data without prior express User consent,
          whether such data is obtained directly from the User or otherwise
          through the use of the Application.
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You must provide clear and complete information to Users and You and
          Your dealership must comply with all applicable privacy and data
          collection laws and regulations with respect to all communications,
          and any collection, use or disclosure of User or device data. You
          should provide a clearly defined justification and User benefit that
          is presented to the User at the time You obtain consent. Furthermore,
          You and Your dealership must take appropriate steps to protect such
          data from unauthorized use, disclosure or access by third parties. If
          a User ceases to consent or affirmatively revokes consent for the
          collection, use or disclosure of such User's data, You and Your
          Dealership must promptly cease all such use. Your dealership must
          provide a privacy policy to Your customers and Users explaining Your
          collection, use, disclosure, sharing, retention, and deletion of User
          or device data.
        </Typography>

        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          Additional Restrictions on Use
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          The Application may not be used for the purpose of harassing, abusing,
          spamming, stalking, threatening or otherwise violating the legal
          rights (such as the rights of privacy and publicity) of others.
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You agree:
        </Typography>
        <UnorderedList>
          <ListItem>
            You will not use the Application for any unlawful or illegal
            activity, nor for any activity which would commit or facilitate the
            commission of a crime, or other tortious, unlawful or illegal act;
          </ListItem>
          <ListItem>
            You will not, directly or indirectly, commit any act intended to
            interfere with any feature or the security of the Application, the
            intent of these Terms, or CDK's business practices including, but
            not limited to, taking actions that may hinder the performance or
            intended use of the Application;
          </ListItem>
          <ListItem>
            You will not use or prompt the Application in a manner that You know
            or reasonably should know generates, or is intended to generate,
            content that is unlawful, harmful or infringes, misappropriates or
            violates the rights of CDK or others. Furthermore, You warrant You
            have all necessary rights and licenses to use the information that
            You display and/or share via the Application.
          </ListItem>
        </UnorderedList>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You agree to comply with all applicable laws, including all applicable
          privacy laws and regulations. You and Your dealership shall be solely
          responsible for, and CDK shall have no responsibility or liability
          whatsoever with respect to, any and all claims, suits, liabilities,
          losses, damages, costs and expenses arising from, or attributable to,
          the Applications and/or the use of those Applications by You, Your
          dealership, or any User.
        </Typography>

        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          Disclaimers
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          CDK does not guarantee the availability, accuracy, completeness,
          reliability, or timeliness of any feature of the Application. To the
          extent You choose to use the Application, You are responsible for Your
          reliance on any such feature.
        </Typography>
        <Typography
          variant='normal'
          as='p'
          style={{ marginBottom: '25px', color: 'inherit' }}
        >
          You acknowledge and agree that CDK reserves the right to revoke or
          otherwise remove Your access to and use of Application at any time in
          its sole discretion. Further, CDK will have no obligation to provide
          any modified, updated or successor version of the Application to You
          and will have no obligation to maintain compatibility with any prior
          version. CDK may extend, enhance, or otherwise modify the Application
          (or any part thereof) provided hereunder at any time without notice,
          but CDK shall not be obligated to provide You with any such updates
          CDK reserves the right to change, suspend, deprecate, deny, limit, or
          disable access to the Application, or any part thereof, at any time
          without notice. In no event will CDK be liable for the removal of or
          disabling of access to any of the foregoing. CDK may also impose
          limits and restrictions on the use of or access to the Application may
          remove the Application or indefinite time periods, may revoke Your
          access to the Application, or may cancel the Application (or any part
          thereof) at any time without notice or liability to You and in its
          sole discretion.
        </Typography>

        <Typography
          variant='subheading'
          as='h3'
          style={{ marginBottom: '20px', color: 'inherit' }}
          fontWeight={600}
        >
          Third-Party Terms
        </Typography>
        <OrderedList>
          <ListItem>
            <strong>Third Party Terms Acceptance.</strong> Covideo LLC
            ("Third-Party Provider,") supports CDK CRM Video. Accordingly, Your
            use of the Application is also governed by these Covideo terms and
            conditions and the Third-Party Privacy Policy, which is incorporated
            herein by reference ("Third-Party Terms"). These Third-Party Terms
            constitute a binding agreement between You and Covideo LLC You
            represent that You have the right and authority to accept these
            Third-Party Terms Your own behalf and on behalf of Your Dealership.
          </ListItem>
          <ListItem>
            <strong>Dealer Accounts.</strong> To use the Application, You will
            be provided an Account via single sign-on (each a "Dealer ID").
            Dealer IDs are Your Confidential Information and You are responsible
            for maintaining the confidentiality of Your Dealer IDs. Dealer IDs
            are for individual use only and may not be shared with any
            third-parties. You are responsible for any and all activity that
            occurs with respect to Your Dealer IDs If You suspect any
            unauthorized use of Your Dealer ID, You must notify Your CDK
            representative immediately.
          </ListItem>
          <ListItem>
            <strong>Suspension Rights.</strong> We and Third-Party Provider
            reserve the right to immediately suspend the Application if You
            violate these Terms, including the Third-Party Terms. Neither We nor
            Third-Party Provider will be liable to You nor to any third party
            for any suspension of the Application.
          </ListItem>
          <ListItem>
            <strong>Additional License Terms</strong>{' '}
            <NestedOrderedList type='I'>
              <ListItem>
                <strong>Third-Party Provider Software.</strong> The Application
                includes software owned by Third-Party Provider, its suppliers
                or licensors ("Software"). Third-Party Provider, its suppliers
                and licensors retain all rights, including all intellectual
                property rights, in and to the Software.
              </ListItem>
              <ListItem>
                <strong>Ownership And License.</strong> The Application,
                including the Software, is licensed and not sold to You. All
                rights not expressly granted to You in the Agreement or these
                Terms, including the Third-Party Terms. are reserved and
                retained by Us, Third-Party Provider, and the applicable owners.
                We grant to You a limited, revocable, non-sublicensable license
                to access and use the Application on behalf of and for the
                benefit or Your Dealership during the term of You Dealership's
                Agreement. Except as contemplated by the Agreement and these
                Terms. The Application, and any part of the Application, may not
                be reproduced, duplicated, copied, sold, resold, visited, or
                otherwise exploited for any commercial purpose without Our
                written consent. You may use the Application only as permitted
                by Applicable Law and these Terms. The licenses granted
                hereunder may be suspended or terminated immediately without
                notice if You breach these Terms.
              </ListItem>
              <ListItem>
                <strong>Restrictions.</strong> You and Your Dealership shall not
                (and shall not permit others to): (i) license, sub-license,
                sell, transfer, distribute or share the Application or make it
                available to any third parties, except that a third-party
                customer may use the Application as a User in connection with
                Your use while You are using the Application; (ii) create
                derivative works based on, build upon, or otherwise modify the
                Application; (iii) disassemble, reverse engineer or decompile
                the Application or otherwise attempt to discover the source
                code, object code or underlying structure, ideas or algorithms
                of the Application; (iv) access the Application in order to
                develop a competing product or service; (v) violate any
                Applicable Law; (vi) intentionally include, send, store or run
                software viruses, worms, Trojan horses or other harmful computer
                code, files, scripts, agents or programs from the Application;
                (vii) intentionally cause a computer to malfunction, regardless
                of how long the malfunction persists; or (viii) alter, disable,
                or erase any computer data, computer programs or computer
                software.
              </ListItem>
              <ListItem>
                <strong>Modifications.</strong> We and Third-Party Provider are
                entitled to modify or update the Application from time to time
                in order to adapt it technically, to change menu guidance or
                layouts or to expand or limit functionality in a way that does
                not materially alter the Application.
              </ListItem>
              <ListItem>
                <strong>Customer Content.</strong> We and/or Third-Party
                Provider will not be liable, directly or indirectly, in any way
                for any damage or loss caused or alleged to be caused by or in
                connection with any Dealer Data uploaded to the Application.
              </ListItem>
              <ListItem>
                <strong>Dealer Data</strong>{' '}
                <NestedOrderedList type='I'>
                  <ListItem>
                    As between the Third-Party Provider and You, all data
                    provided by You, Your Dealership, or any customer User of
                    Your Dealership (collectively, "Dealer Data") is the
                    property of Your Dealership and all rights not granted to
                    Third-Party Provider hereunder shall remain with Your
                    Dealership and any of Your User customers that may provide
                    the data. Our use of Dealer Data is governed by Your
                    Agreement with CDK. You grant to Third-Party Provider a
                    limited, personal, revocable, royalty free,
                    non-sublicensable, non-exclusive, non-transferable (other
                    than as set out herein), worldwide license to (i) process
                    and analyze Dealer Data solely for the purposes of providing
                    and supporting the Application; (ii) to generate statistics
                    and produce reports for CDK and You based on the Dealer
                    Data; and (iii) use aggregated, anonymized Dealer Data to
                    improve and customize the Application. Third-Party Provider
                    may share Dealer Data with CDK but will not otherwise share
                    any of the Dealer Data with any third parties without Your
                    consent and shall take all reasonably appropriate
                    confidentiality and security measures to protect such Dealer
                    Data.
                  </ListItem>
                  <ListItem>
                    <strong>Lawful Basis.</strong> You acknowledge, agree and
                    warrants that You have all rights necessary to collect, use,
                    process, transfer and disclose Your Dealer Data You provide
                    or collect within the Application, and that Your use of such
                    Dealer Data is conducted pursuant to a lawful basis (as
                    defined by Applicable Law), including consent where required
                    by Applicable Law (collectively "Privacy Consents"). Upon
                    request by Third-Party Provider, Your Dealership shall
                    provide proof of such lawful basis. CDK, Third-Party
                    Provider relies exclusively on the Dealership to obtain all
                    Privacy Consents from, and provide all required disclosures
                    to, Users as required under Applicable Law.
                  </ListItem>
                  <ListItem>
                    <strong>Statistical Information.</strong> Third-Party
                    Provider may monitor Your and Your Users use of the
                    Application and compile this data with other data in an
                    aggregate and anonymous manner that does not identify You,
                    Your Dealership, or a User to derive statistical and
                    performance information ("Statistical Information").
                    Third-Party Provider uses Statistical Information to produce
                    reports and improve and customize the Application.
                    Third-Party Provider may make such Statistical Information
                    available to CDK as well as publicly available, provided
                    that such Statistical Information: (i) is not able to be
                    de-anonymized; (ii) does not include any data that would
                    enable the identification of You, Your Dealership or a User;
                    or (iii) would not constitute the disclosure of Confidential
                    Information. Third-Party Provider and CDK retains all
                    rights, title and interest in and to such Statistical
                    Information.
                  </ListItem>
                  <ListItem>
                    <strong>Content Preservation and Disclosure.</strong>{' '}
                    Third-Party Provider may preserve, store and/or disclose
                    Dealer Data if required to do so by law or in the good faith
                    belief that such preservation or disclosure is reasonably
                    necessary to comply with legal processes.
                  </ListItem>
                </NestedOrderedList>
              </ListItem>
            </NestedOrderedList>
          </ListItem>
          <ListItem>
            <strong>Security.</strong> Third-Party Provider shall maintain
            appropriate administrative, physical, and technical safeguards
            designed to protect the security of the Application and Dealer Data
            in accordance with the Third-Party Provider security standards.
          </ListItem>
          <ListItem>
            <strong>Subcontractors.</strong> We and Third-Party Provider may use
            third party subcontractors to provide limited parts of the
            Application from time to time, including data storage and processing
            and content delivery ("Subcontractors"). You consent to us
            subcontracting these services to the Subcontractors, provided that
            Third-Party Provider shall ensure that these Subcontractors comply
            with the terms of this Agreement applicable to Third-Party Provider
            and that Third-Party Provider shall remain liable to Your Dealership
            for any breach of these Third-Party Terms and Conditions by a
            Subcontractor.
          </ListItem>
          <ListItem>
            <strong>Additional Third-Party Services.</strong> You may choose to
            integrate, connect, or otherwise use the Application with other
            services not provided by Third-Party Provider ("Non-Provider
            Services") and in doing so grant Third-Party Provider permission to
            interoperate with the Non-Provider Services and share Dealer Data
            with the Non- Provider Services as directed by the You and/or
            Non-Provider Services. If You use Non-Provider Services: (a) You
            warrant that if You uses the Application to upload or make public
            Dealer Data to Non-Provider Services, including but not limited to
            YouTube, that such Dealer Data shall comply with the third-party
            terms of use (for example{' '}
            <LegalLink
              href='https://www.youtube.com/t/terms'
              target='_blank'
              style={{ textDecoration: 'underline', color: '#196fe1' }}
              rel='noreferrer'
            >
              YouTube's Terms of Service
            </LegalLink>
            ) in effect and as updated from time to time; (b) Third-Party
            Provider does not warrant or support Non-Provider Services; (c) as
            between Third-Party Provider and You, You assume all responsibility
            for the Non-Provider Services and any disclosure, modification or
            deletion of Dealer Data by the Non-Provider Services; and (d)
            Third-Party Provider shall have no liability, and You are not
            relieved of any obligations under these Terms or the Agreement or
            entitled to any refund, credit, or other compensation, due to any
            unavailability of the Non-Provider Services or any change in the
            ability of Third-Party Provider to interoperate with the
            Non-Provider Services.
          </ListItem>
          <ListItem>
            <strong>Warranties</strong>{' '}
            <NestedOrderedList type='I'>
              <ListItem>
                Third-Party Provider works hard to provide the best products;
                however, You understand and expressly agree that use of the
                Application is provided "as is," and We and Third-Party Provider
                make no guarantees that it always will be safe, secure, or
                error-free, or that it will function without disruptions,
                delays, or imperfections. To the extent permitted by law,
                Third-Party Provider also DISCLAIMS ALL WARRANTIES, WHETHER
                EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
                NON-INFRINGEMENT.
              </ListItem>
              <ListItem>
                <strong>Maintenance and Repairs.</strong> Third-Party Provider
                shall use commercially reasonable efforts to ensure that
                availability of the Application will be uninterrupted and that
                transmissions will be error-free. However, Your access to the
                Application may be occasionally suspended or restricted to allow
                for repairs, maintenance or the introduction of new facilities
                or features. Third-party Provider will attempt to limit the
                frequency and duration of any such suspension or restriction and
                will use commercially reasonable efforts to alert or notify You
                in the event of any scheduled or non-scheduled suspension of the
                Application. Due to the nature of technical outages, Third-Party
                Provider cannot guarantee notice prior to unplanned outages and
                will not be held responsible for any delay or failure to comply
                with Third-Party Provider's obligations under these conditions
                if the delay or failure arises from any because which is beyond
                its reasonable control.
              </ListItem>
            </NestedOrderedList>
          </ListItem>
          <ListItem>
            <strong>Indemnification</strong>{' '}
            <NestedOrderedList type='I'>
              <ListItem>
                <strong>Dealership Indemnification.</strong> Dealership shall
                indemnify, defend and hold harmless Third-Party Provider and CDK
                from and against all liabilities, damages and costs (including
                settlement costs and reasonable attorneys' fees) arising out of
                or related to any claim by a third party against Third-Party
                Provider or its affiliates regarding: (i) Dealer Data; (ii)
                failure by the Dealership to obtain any of the necessary Privacy
                Consents required by these Terms; (iii) Dealership's use of the
                Application in violation of these Terms; (vi) violations of
                Dealership's obligations of privacy to any Person; (v) Your
                violation of Applicable Law; and/or (vi) Dealership's negligence
                or willful misconduct.
              </ListItem>
              <ListItem>
                <strong>Third-Party Provider Indemnification.</strong>{' '}
                Third-Party Provider will indemnify, defend and hold harmless
                Dealership from and against all liabilities, damages and costs
                (including settlement costs and reasonable attorneys' fees)
                arising out of any claim by a third party against the Dealership
                to the extent based on an allegation that Third-Party Provider's
                technology used to provide the Application the Dealership
                infringes or misappropriates any copyright, trade secret, patent
                or trademark right of a third party that is issued or registered
                in the United States. In no event will Third-Party Provider have
                any obligations or liability under this section arising out of
                or related to any Dealer Data provided by Dealership, Users, or
                other third parties. Third-Party Provider shall not be required
                to indemnify Dealership in the event of: (a) modification of the
                Application by Dealership, its employees, or contractors in
                conflict with Dealership's obligations or as a result of any
                prohibited activity as set forth herein; (b) use of the
                Application in a manner inconsistent with the Documentation; (c)
                use of the Application in combination with any other
                application, product, or service not provided by CDK if such
                claim would not have occurred without such combination; or (d)
                use of the Application in a manner not otherwise contemplated by
                the Agreement or these Terms.
              </ListItem>
              <ListItem>
                <strong>Possible Infringement.</strong> If We or Third-Party
                Provider believe the Application infringes or may be alleged to
                infringes a third party's intellectual property rights, then We
                or Third-Party Provider may: (i) obtain the right for You (at
                Our expense) to continue using the Application; (ii) provide a
                non-infringing functionally equivalent replacement; or (iii)
                modify the Application so that they no longer infringe. If We or
                Third-Party Provider do not believe that the options described
                in this section are commercially reasonable, then We or
                Third-Party Provider may suspend or terminate Your use of the
                affected Application features.
              </ListItem>
              <ListItem>
                <strong>Process.</strong> The party seeking indemnification will
                promptly notify the other party of the claim and cooperate with
                the other party in defending the claim. The indemnifying party
                will have full control and authority over the defense, except
                that: (i) any settlement requiring the party seeking
                indemnification to admit liability requires prior written
                consent, not to be unreasonably withheld or delayed; and (ii)
                the other party may join the defense with its own counsel at its
                expense.
              </ListItem>
              <ListItem>
                <strong>Exclusive Remedy.</strong> The indemnities above are
                Third-Party Provider's and Dealership's only remedy under these
                Third-Party Terms for third party infringement claims and
                actions.
              </ListItem>
            </NestedOrderedList>
          </ListItem>
          <ListItem>
            <strong>Limitations Of Liability And Damages</strong>{' '}
            <NestedOrderedList type='I'>
              <ListItem>
                <strong>Limitations Of Liability.</strong> EXCEPT FOR EACH
                PARTY'S INDEMNIFICATION OBLIGATIONS, TO THE EXTENT PERMITTED BY
                APPLICABLE LAW, THE MAXIMUM AGGREGATE LIABILITY OF EACH PARTY
                UNDER THESE TERMS, WHETHER BASED ON CONTRACT, IN TORT OR ANY
                OTHER LEGAL OR EQUITABLE THEORY, SHALL BE LIMITED TO ONE
                THOUSAND DOLLARS ($1,000.00)
              </ListItem>
              <ListItem>
                <strong>Exclusion Of Damages.</strong> EXCEPT FOR EACH PARTY'S
                INDEMNIFICATION OBLIGATIONS, TO THE EXTENT PERMITTED BY
                APPLICABLE LAW, NEITHER PARTY SHALL BE LIABLE UNDER THESE TERMS
                FOR: (I) INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY
                OR PUNITIVE DAMAGES; OR (II) LOSS OF USE, DATA, BUSINESS,
                REVENUE OR PROFITS (IN EACH CASE WHETHER DIRECT OR INDIRECT),
                EVEN IF THE PARTY KNEW OR SHOULD HAVE KNOWN THAT SUCH DAMAGES
                WERE FORESEEABLE.
              </ListItem>
            </NestedOrderedList>
          </ListItem>
          <ListItem>
            <strong>Privacy And Confidential Information</strong>{' '}
            <NestedOrderedList type='I'>
              <ListItem>
                <strong>Privacy Policy.</strong> Third-Party Provider's
                collection and use of Your information and information regarding
                Users is governed by Third-Party Provider's Privacy Policy. You
                understand that through Your use of the Application, You consent
                to the collection and use of this information. As part of
                providing You the Application, We and Third-Party Provider may
                need to provide You with certain communications, such as service
                announcements and administrative messages. These communications
                are considered part of the Application and Your Account.
              </ListItem>
              <ListItem>
                <strong>Confidential Information.</strong> Each party (the
                "Receiving Party") understands that the other party (the
                "Disclosing Party") has disclosed or may disclose information
                relating to the Disclosing Party's business (together
                "Confidential Information" of the Disclosing Party). Such Your
                Dealer Data and Your Dealer ID. The Receiving Party agrees: (i)
                to take reasonable precautions to protect such Confidential
                Information; and (ii) not to use (except as permitted in these
                Third-Party Terms) or divulge to any third person such
                Confidential Information. The Disclosing Party agrees that the
                foregoing shall not apply with respect to Confidential
                Information after five years following the termination of this
                Agreement or any Confidential Information that the Receiving
                Party can demonstrate that: (i) is or becomes generally known to
                the public; (ii) was known to the Receiving Party prior to its
                disclosure by the Disclosing Party without breach of any
                obligation to the Disclosing Party; (iii) is received from a
                third party without any obligation of confidentiality to a third
                party or breach of any obligation of confidentiality to the
                Disclosing Party; (iv) was independently developed by the
                Receiving Party without reference to the Disclosing Party's
                Confidential Information; or (v) is deemed non-confidential by
                law. Receiving Party may disclose Confidential Information where
                disclosure is required by a court of competent jurisdiction or
                other governmental authority, provided, however, that the
                Receiving Party provides prior written notice to the other of
                any such order, to the extent permitted by Applicable Law, and
                limits disclosure to the scope of such order. The Receiving
                Party shall promptly return to the Disclosing Party or destroy
                (with certification of such destruction provided by the
                Receiving Party upon request) all Confidential Information of
                the Disclosing Party in its possession or control upon request
                from the Disclosing Party.
              </ListItem>
            </NestedOrderedList>
          </ListItem>
          <ListItem>
            <strong>Term.</strong> These Terms shall remain in effect for the
            Term of Your Agreement with CDK and for so long as You use the
            Application.
          </ListItem>
          <ListItem>
            <strong>Notice.</strong> All notices to Third-Party Provider
            hereunder shall be sent to{' '}
            <LegalLink
              href='mailto:legal@covideo.com'
              style={{ textDecoration: 'underline', color: '#196fe1' }}
            >
              legal@covideo.com
            </LegalLink>
            .
          </ListItem>
          <ListItem>
            <strong>Survival.</strong> Any provision of these Terms required for
            their construction or enforcement, shall survive termination of
            these Terms for any reason.
          </ListItem>
          <ListItem>
            <strong>Definitions.</strong> Capitalized terms used in these Terms
            shall have the following meanings:
            <NestedOrderedList type='a'>
              <ListItem>
                <strong>"Account"</strong> means the Dealership account, which
                includes a username and password, used by Dealership to access
                and use the Application;
              </ListItem>
              <ListItem>
                <strong>"Applicable Laws"</strong> means all statutes, codes,
                rules, regulations, by-laws, judicial or arbitral or
                administrative or ministerial or departmental or regulatory
                judgments, orders, decisions, rulings or awards, policies,
                guidelines, or any provisions of the foregoing, including
                general principles of common and civil law and equity, binding
                on or affecting the Person referred to in the context in which
                such word is used;
              </ListItem>
              <ListItem>
                <strong>"Dealer Data"</strong> means non-anonymized, aggregated
                data provided or generated by Dealerships and the Users in
                connection with the Application, including personal information,
                login credentials, and other information that relates to such
                parties' use of the Application;
              </ListItem>
              <ListItem>
                <strong>"Documentation"</strong> means documentation relating to
                the operation and use of the Application that are provided to
                Dealership under these Terms, as may be updated from time to
                time;
              </ListItem>
              <ListItem>
                <strong>"Person"</strong> means a natural person or any legal,
                commercial or governmental entity, such as, but not limited to,
                a corporation, general partnership, joint venture, limited
                partnership, limited liability company, trust, business
                association, group acting in concert, or any person acting in a
                representative capacity.
              </ListItem>
              <ListItem>
                <strong>"Third- Party Privacy Policy"</strong> means the terms
                located at{' '}
                <LegalLink
                  href='https://www.covideo.com/privacy-policy/'
                  target='_blank'
                  style={{ textDecoration: 'underline', color: '#196fe1' }}
                  rel='noreferrer'
                >
                  https://www.covideo.com/privacy-policy/
                </LegalLink>
              </ListItem>
              <ListItem>
                <strong>"Users"</strong> means Dealership's employees,
                representatives, consultants, contractors, agents, and customers
                who are authorized to use the Application in connection with
                Dealerships use of the Application;
              </ListItem>
              <ListItem>
                <strong>"Third-Party Provider Platform"</strong> means the code,
                technology and servers used in the operation and provision of
                the Services and includes the Documentation and Software;
              </ListItem>
            </NestedOrderedList>
          </ListItem>
        </OrderedList>
      </MainWrapper>
    </Container>
  );
};
